import { Col, Row } from "antd";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../../../../../../contexts/AuthContext";
import query from "../../../../../../server/constants.api";
import logger from "../../../../../../server/server";
import useFetch from "../../../../../../server/useFetch";
import {
  PageContent,
  PageTitle,
} from "../../../../../../styles/global/Pages.styled";
import Theme from "../../../../../../styles/Theme/Theme";
import { months, years } from "../../../../../../utils/dummydata";
import { isEmpty } from "../../../../../../utils/hooks/isEmpty";
import { orbitCamera } from "../../../../../../utils/renders/render-helper";
import { SelectAtomic } from "../../../../Atomics/SelectAtomic";
import { Text } from "../../../../Atomics/Text";
import { Widget } from "../../../../Atomics/Widget";
import { FloorVacancyComponent } from "../../../FloorVacancyComponent/FloorVacancyComponent";
import { StackedFloorsComponent } from "../../../StackedFloorsComponent/StackedFloorsComponent";

export const BuildingOccupationHistoric = ({
  item,
  currentFloor,
  ...props
}) => {
  // Hook de tradução
  const { t } = useTranslation();
  const { user, tenant } = useAuthContext();
  useEffect(() => {
    logger.info("User " + user?.Username + " entered BuildingOccupationHistoric successfully! Tenant: " + tenant);
  }, []);

  // Definindo o mês e ano atuais
  const currentMonth = new Date().getMonth() + 1; // JavaScript getMonth() retorna o mês de 0 a 11, então adicionamos 1
  const [selectedMonth, setSelectedMonth] = useState(
    months(t).find((month) => month.value === currentMonth)?.value
  );
  const [selectedYear, setSelectedYear] = useState(2024);
  // const [selectedTemp, setselectedTemp] = useState(5);
  const [orbitCameraVal, setOrbitCamera] = useState(false);
  const [orbitControls, setOrbitControls] = useState();

  function toggleCamera() {
    orbitCamera(orbitControls, !orbitCameraVal);
    setOrbitCamera(!orbitCameraVal);
  }

  // Hook customizado para buscar dados do histórico de consumo energético
  const { data: reservationsRoomsHistory, refetch: refetchBuildingOccupation, isFetching: reservationsRoomsHistoryisFetching,
  } = useFetch("/registry/occupation/reservations/rooms/history", "reservationsRoomsHistory",
    {
      buildingID: item?.id,
      month: selectedMonth,
      year: selectedYear,
    },
    item?.id ?? false, null, query.middlewareURL);

  //Open-spaces
  const { data: reservationsHistory, refetch: refetchBuildingHistoryOccupation, isFetching: reservationsHistoryisFetching,
  } = useFetch("/registry/occupation/reservations/history", "reservationsHistory",
    {
      buildingID: item?.id,
      month: selectedMonth,
      year: selectedYear,
    },
    item?.id ?? false, null, query.middlewareURL);

  useEffect(() => {
    refetchBuildingOccupation();
    refetchBuildingHistoryOccupation();
    setOrbitCamera(false);
  }, [selectedMonth, selectedYear]);

  return (
    <PageContent className={clsx("building_room_details", props?.className)}>
      <Row gutter={[16, 16]}>
        {/* Define o layout de linhas com largura total */}
        <Col span={24} style={{ alignContent: "center" }}>
          <Row>
            <Col span={8}>
              <Row>
                <Col span={24}>
                  <h3>
                    {item?.name} | {t("Occupation").toLocaleUpperCase()}{" "}
                    {/* Changes the title to upperCase and translates it */}
                  </h3>
                </Col>
              </Row>
            </Col>
            <Col span={12} offset={4} style={{ alignContent: "center" }}>
              <Row gutter={16}>
                <Col span={6} offset={12}>
                  <SelectAtomic
                    optionsData={months(t)}
                    handleOptionsChange={(value) => {
                      setSelectedMonth(value);
                    }}
                    defaultValue={selectedMonth}
                    fullWidth={true}
                  />
                </Col>
                <Col span={6}>
                  <SelectAtomic
                    optionsData={years}
                    handleOptionsChange={(value) => {
                      setSelectedYear(value);
                    }}
                    defaultValue={selectedYear}
                    fullWidth={true}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <PageTitle>
            <Text
              $fontColor="coolgray-12"
              $fontSize="text_md"
              $weight="medium"
              $marginRight="s03"
            >
              {t("Open-Space")}
            </Text>
          </PageTitle>
        </Col>
        <Col span={24}>
          <Row gutter={[32, 32]}>
            <Col
              span={5}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Widget
                data={{
                  background: "white", // Define o fundo como transparente
                  title: t("Average Reservations Made"), // Título do Widget traduzido
                  icon: null, // Nenhum ícone definido
                  charts: [
                    {
                      chartType: "bigNumberChart",
                      chartId: "bigNumberChartOne",
                      height: "65px",
                      isFetching: reservationsHistoryisFetching,
                      data: reservationsHistory
                        ? { number: reservationsHistory?.averageReservations }
                        : null,
                    },
                  ],
                }}
              />
              <Widget
                data={{
                  background: "white", // Define o fundo como transparente
                  title: t("Average Check-ins Made"), // Título do Widget traduzido
                  icon: null, // Nenhum ícone definido
                  charts: [
                    {
                      chartType: "bigNumberChart",
                      chartId: "bigNumberChartOne",
                      height: "65px",
                      isFetching: reservationsHistoryisFetching,
                      data: reservationsHistory
                        ? { number: reservationsHistory.averageCheckIns }
                        : null,
                    },
                  ],
                }}
              />
              <Widget
                data={{
                  background: "white", // Define o fundo como transparente
                  title: t("Average Missing Checkout"), // Título do Widget traduzido
                  icon: null, // Nenhum ícone definido
                  charts: [
                    {
                      chartType: "bigNumberChart",
                      chartId: "bigNumberChartOne",
                      height: "65px",
                      isFetching: reservationsHistoryisFetching,
                      data: reservationsHistory
                        ? {
                          number: reservationsHistory.averageMissingCheckouts,
                        }
                        : null,
                    },
                  ],
                }}
              />
            </Col>
            <Col span={11}>
              <Row gutter={[16, 16]}>
                <Widget
                  data={{
                    background: "white",
                    title: t("Seats Reservation"),
                    icon: null,
                    charts: [
                      {
                        chartType: "areaChartApex",
                        chartId: "areaChartApexOne",
                        height: "348px",
                        isFetching: reservationsHistoryisFetching,
                        data:
                          reservationsHistory?.deskReservations &&
                            !isEmpty(reservationsHistory?.deskReservations)
                            ? sereializeSeatsReservations(
                              reservationsHistory.deskReservations,
                              t
                            )
                            : null,
                      },
                    ],
                  }}
                />
              </Row>
            </Col>
            <Col span={8}>
              <Row gutter={[16, 16]}>
                <Widget
                  className="full-h"
                  data={{
                    background: "white",
                    title: t("Occupation Map"),
                    icon: null,
                    buttons: [
                      {
                        key: t("360"),
                        title: t("360º"),
                        onButtonClick: () => toggleCamera(),
                        isActive: orbitCameraVal,
                      },
                    ],
                  }}
                >
                  <div style={{ height: "336px" }}>
                    {currentFloor?.value === item?.id ? (
                      <StackedFloorsComponent
                        building={item}
                        metric={"occupation"}
                        setOrbitControls={setOrbitControls}
                      />
                    ) : (
                      <FloorVacancyComponent
                        building={item}
                        currentFloor={currentFloor}
                        metric={"occupation"}
                        setOrbitControls={setOrbitControls}
                      />
                    )}
                  </div>
                </Widget>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <PageTitle>
            <Text
              $fontColor="coolgray-12"
              $fontSize="text_md"
              $weight="medium"
              $marginRight="s03"
            >
              {t("Rooms")}
            </Text>
          </PageTitle>
        </Col>
        <Col span={24}>
          <Row gutter={[32, 32]}>
            <Col
              span={5}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Widget
                data={{
                  background: "white", // Define o fundo como transparente
                  title: t("Rooms Reservations"), // Título do Widget traduzido
                  icon: null, // Nenhum ícone definido
                  charts: [
                    {
                      chartType: "bigNumberChart",
                      chartId: "bigNumberChartOne",
                      height: "60px",
                      isFetching: reservationsRoomsHistoryisFetching,
                      data: reservationsRoomsHistory
                        ? { number: reservationsRoomsHistory.averageCheckIns }
                        : null,
                    },
                  ],
                }}
              />
              <Widget
                data={{
                  background: "white", // Define o fundo como transparente
                  title: t("Rooms Check-in Carried Out"), // Título do Widget traduzido
                  icon: null, // Nenhum ícone definido
                  charts: [
                    {
                      chartType: "bigNumberChart",
                      chartId: "bigNumberChartOne",
                      height: "60px",
                      isFetching: reservationsRoomsHistoryisFetching,
                      data: reservationsRoomsHistory
                        ? {
                          number:
                            reservationsRoomsHistory.averageReservations,
                        }
                        : null,
                    },
                  ],
                }}
              />
            </Col>
            <Col span={11}>
              <Row gutter={[16, 16]}>
                <Widget
                  data={{
                    background: "white",
                    title: t("Rooms Reservations"),
                    icon: null,
                    charts: [
                      {
                        chartType: "areaChartApex",
                        chartId: "areaChartApexOne",
                        height: "198px",
                        isFetching: reservationsRoomsHistoryisFetching,
                        data:
                          reservationsRoomsHistory?.roomReservations &&
                            !isEmpty(reservationsRoomsHistory?.roomReservations)
                            ? sereializeSeatsReservations(
                              reservationsRoomsHistory.roomReservations,
                              t
                            )
                            : null,
                      },
                    ],
                  }}
                />
              </Row>
            </Col>
            <Col span={8}>
              <Row gutter={[16, 16]}>
                <Widget
                  data={{
                    background: "white",
                    title: t("Average Use Of Rooms"),
                    icon: null,
                    charts: [
                      {
                        chartType: "stackedColumnsChartApex",
                        chartId: "stackedColumnsChartApexOne",
                        height: "198px",
                        isFetching: reservationsRoomsHistoryisFetching,
                        data: null, //reservationsRoomsHistory?.averageRoomUtilization
                      },
                    ],
                  }}
                />
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </PageContent>
  );
};

const sereializeSeatsReservations = (data, t) => {
  let seriesData = [];

  Object.entries(data).map((entry) => {
    const [key, value] = entry;

    if (isValidDate(key)) {
      seriesData.push({
        x: key,
        y: value,
      });
    }
  });

  const sortedData = seriesData.sort((a, b) => {
    if (a.x < b.x) {
      return -1;
    }
    if (a.x > b.x) {
      return 1;
    }
    return 0;
  });
  seriesData = sortedData;

  return {
    series: [
      {
        name: t("Reserved Rooms"),
        data: seriesData,
      },
    ],
    categories: null,
    // xAxisType: "datetime",
    labelFormat: "dd/MM",
    tooltip: "dd/MM/yyyy",
    markerSize: 3,
    unit: "",
    columnWidth: 20,
    colors: [Theme.color["occupation"], Theme.color["occupation-free"]],
  };
};

function isValidDate(dateString) {
  const date = new Date(dateString);
  return !isNaN(date.getTime());
}
